import { render, staticRenderFns } from "./study-completion-chart.vue?vue&type=template&id=037edc7d&scoped=true&"
import script from "./study-completion-chart.vue?vue&type=script&lang=js&"
export * from "./study-completion-chart.vue?vue&type=script&lang=js&"
import style0 from "./study-completion-chart.vue?vue&type=style&index=0&id=037edc7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037edc7d",
  null
  
)

component.options.__file = "study-completion-chart.vue"
export default component.exports